export default "__VITE_ASSET__VOvHTsr5__"